export type CmFieldGroup = 'ri' | 'total';

export type CmField = {
  key: string;
  label: string;
  subLabel: string;
  group: CmFieldGroup;
};

export const CM_UNCALIBRATED_FIELDS: CmField[] = [
  { key: 'uncalibrated_ri0_area', label: 'Ri0', subLabel: 'Area', group: 'ri' },
  { key: 'uncalibrated_ri1_area', label: 'Ri1', subLabel: 'Area', group: 'ri' },
  { key: 'uncalibrated_ri2_area', label: 'Ri2', subLabel: 'Area', group: 'ri' },
  { key: 'uncalibrated_ri3_area', label: 'Ri3', subLabel: 'Area', group: 'ri' },
  { key: 'uncalibrated_ri4_area', label: 'Ri4', subLabel: 'Area', group: 'ri' },
  { key: 'uncalibrated_ri5_area', label: 'Ri5', subLabel: 'Area', group: 'ri' },
  { key: 'uncalibrated_coating_breakdown_area', label: 'CB', subLabel: 'Area', group: 'ri' },
];

export const CM_CALIBRATED_FIELDS: CmField[] = [
  { key: 'calibrated_ri0_area', label: 'Ri0', subLabel: 'Area', group: 'ri' },
  { key: 'calibrated_ri1_area', label: 'Ri1', subLabel: 'Area', group: 'ri' },
  { key: 'calibrated_ri2_area', label: 'Ri2', subLabel: 'Area', group: 'ri' },
  { key: 'calibrated_ri3_area', label: 'Ri3', subLabel: 'Area', group: 'ri' },
  { key: 'calibrated_ri4_area', label: 'Ri4', subLabel: 'Area', group: 'ri' },
  { key: 'calibrated_ri5_area', label: 'Ri5', subLabel: 'Area', group: 'ri' },
  { key: 'calibrated_coating_breakdown_area', label: 'CB', subLabel: 'Area', group: 'ri' },
];

export const CM_REMEDIATION_FIELDS: CmField[] = [
  { key: 'remediated_ri0', label: 'Ri0', subLabel: 'Area', group: 'ri' },
  { key: 'remediated_ri1', label: 'Ri1', subLabel: 'Area', group: 'ri' },
  { key: 'remediated_ri2', label: 'Ri2', subLabel: 'Area', group: 'ri' },
  { key: 'remediated_ri3', label: 'Ri3', subLabel: 'Area', group: 'ri' },
  { key: 'remediated_ri4', label: 'Ri4', subLabel: 'Area', group: 'ri' },
  { key: 'remediated_ri5', label: 'Ri5', subLabel: 'Area', group: 'ri' },
  { key: 'total_risk_score', label: 'Remaining', subLabel: 'Score', group: 'total' },
];
